export type PlanDefinition = {
  id: number;
  nameColor: string;
  name: string;
  subtitle: string;
  buttonText?: string;
  features: string[];
  isRecommended: boolean;
};

export const BILLING_PLANS: PlanDefinition[] = [
  {
    id: 1,
    nameColor: "#f01f46",
    name: "Starter",
    subtitle:
      "Send personalized gifts to your clients easier than ever before at no extra charge.",
    buttonText: "Downgrade to Starter",
    features: [
      "Pay via credit",
      "AI Personalized Gifts",
      "Gifts from $50 - $1,000",
      "Send gifts via email",
      "* Gain Referrals Credits",
      "Dashboard with live tracking and reporting",
      "Personalized note with gifts ",
      "*International shipping",
    ],
    isRecommended: false,
  },
  {
    id: 2,
    nameColor: "#00b3ff",
    name: "Growth",
    subtitle:
      "Keep your clients delighted with automation and build your brand",
    features: [
      "Everything from STARTER",
      "Pay as you go",
      "Automated Review Collection on your preferred platform (Google/Facebook...etc.)",
      "Ask recipients for Referrals",
      "Customise email templates",
      "Bulk send gifts",
      "Collect recipients birthdays",
      "Training sessions with our success team",
      "Online customer support",
    ],
    isRecommended: true,
  },
  {
    id: 3,
    nameColor: "#ffd966",
    name: "Scale",
    subtitle:
      "Advanced features to grow your business and connect with clients",
    features: [
      "Everything from GROWTH",
      "Keep your clients delighted with automation and build your own brand",
      "Your brand on packaging",
      "CRM integration (Automates all your gifts)",
      "Set up Automated Gift Campaigns",
      "*Team Management",
      "3 Free team seats",
      "3 Custom CTAs in chat",
      "Add video messages",
      "Actionable Insights to drive ROI",
      "Secret Santa",
    ],
    isRecommended: false,
  },
  {
    id: 4,
    nameColor: "#35df90",
    name: "Enterprise",
    subtitle:
      "Take full control of your gifting and customer relationship workflows",
    features: [
      "Everything from SCALE",
      "Single Sign On (SSO)",
      "Customize chat flow",
      "Unlimited CTAs in chat",
      "Your brand on products (Swag Management)",
      "5 Free team seats",
      "Branded chat experience",
      "Advanced organizational permission",
      "Account Consolidation",
      "View customer preference data such as their likes & interests, etc.",
      "Send Swag / Merchandise with your gifts",
      "Send direct mailer postcards in bulk",
    ],
    isRecommended: false,
  },
];

export function findBillingPlanByName(
  planName?: string | null
): PlanDefinition | undefined {
  if (!planName?.trim()) return undefined;
  const normalized = planName.trim().toLowerCase();
  return BILLING_PLANS.find((plan) => plan.name.toLowerCase() === normalized);
}
